import { useEffect, useState } from "react";
import { ArrowsClockwise } from "@phosphor-icons/react";

export const UpdateNotice = () => {
  const [show, setShow] = useState(() => !!window.__swWaiting);

  useEffect(() => {
    const on = () => setShow(true);
    window.addEventListener("sw-update-available", on);
    return () => window.removeEventListener("sw-update-available", on);
  }, []);

  if (!show) return null;

  const apply = () => {
    window.__swUpdateRequested = true;
    window.__swWaiting?.postMessage({ type: "SKIP_WAITING" });
    setTimeout(() => window.location.reload(), 1500);
  };

  return (
    <div data-testid="update-notice"
      className="fixed bottom-20 sm:bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 bg-zinc-900 border border-indigo-500/40 shadow-xl shadow-black/50 rounded-full pl-4 pr-1.5 py-1.5 whitespace-nowrap">
      <span className="text-sm text-zinc-200">Nova versão disponível</span>
      <button data-testid="update-notice-button" onClick={apply}
        className="flex items-center gap-1.5 bg-indigo-600 hover:bg-indigo-500 active:scale-[0.98] text-white text-sm font-semibold px-4 py-2 min-h-[40px] rounded-full transition-all">
        <ArrowsClockwise size={15} /> Atualizar
      </button>
    </div>
  );
};
